import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import Sweetalert from 'sweetalert2'

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded'

Vue.prototype.$bus = new Vue()
Vue.prototype.$http = axios
Vue.prototype.$swal = Sweetalert

new Vue({
  el: '#app',
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js